export default {
  DARK: {
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    blockTitle: p => p.primaryLight,
    backgroundColor: p => p.tertiaryDark,
    background: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    blockTitle: p => p.primaryDark,
    backgroundColor: p => p.tertiaryLight,
    background: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    blockTitle: p => p.primaryDark,
    backgroundColor: p => p.tertiaryExtraLight,
    background: p => p.tertiaryExtraLight
  }
}
